import { useEffect } from "react"

export const useScrollOnRender = () => {
	useEffect(() => {
		if (window.location.hash) {
			const element = document.body.querySelector(window.location.hash)
			if (element) {
				element.scrollIntoView({
					behavior: 'smooth',
				})
			}
		}
	}, [])
}
